import { HttpClient, HttpEventType, HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { forEach } from 'jszip';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BaseService } from '../../core/services/shared/base.service';
//import { CommonService } from '../../core/services/v2/common.service';
import { WindowLoaderService } from '../../shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-npi-data-pull',
  templateUrl: './npi-data-pull.component.html',
  styleUrls: ['./npi-data-pull.component.scss']
})
export class NpiDataPullComponent implements OnInit {
  uploadStatus: string = "";
  progress: number;
  showProgress: boolean;
  progressInfos = [];
  selectedFiles: FileList;
  fileInfos: Observable<any>;
  constructor(private _baseservice: BaseService,
    private loaderService: WindowLoaderService,
    private _snackBar: MatSnackBar,
    private http: HttpClient) { }

  ngOnInit() {
  }

  async attachFile(event) {
    this.progressInfos = [];
    this.progress = 1;
    this.uploadStatus = "Uploading data ...."

    let file: File;
    const allFiles = event.target.files;
    const length = allFiles.length;
    for (let i = 0; i < length; i++) {
      file = allFiles[i];
      this.progressInfos[i] = { value: 0, fileName: file.name, isSuccess: false };
    }


    for (let i = 0; i < length; i++) {
      file = allFiles[i];
      //await this.upload(i, event.target.files[i]);

      let npiDataFileForm = new FormData();

      npiDataFileForm.append('NPIDataSource', file);
      this.loaderService.show();

      console.log(`File Number : ${i}, FileName : ${file.name} Date: ${Date.now}`);
      //this.textToshow = `Uploading file ${i + 1} of ${event.target.files.length}`;

      await this._baseservice.uploadwithprogress('Common/UploadNPIData', npiDataFileForm, this.progress)
        .pipe(
          map((event: any) => {
            if (event.type == HttpEventType.UploadProgress) {
              this.progressInfos[i].value = Math.round(100 * event.loaded / event.total);
            } else if (event.type == HttpEventType.Response) {
              this.progressInfos[i].isSuccess = true;
              this.loaderService.hide();
            }
          }),
          catchError((err: any) => {
            this.progress = null;
            alert(err.message);
            return throwError(err.message);
          })
        )
        .toPromise();

      //.subscribe((event) => {
      //  debugger;
      //  if (event.type === HttpEventType.UploadProgress) {
      //    this.progressInfos[i].value = Math.round(100 * event.loaded / event.total);
      //  } else if (event instanceof HttpResponse) {
      //    debugger;
      //    console.log("file uploaded");
      //    //this.progressInfos[i].value = Math.round(100 * (i + 1) / event.target.files.length);

      //    this.loaderService.hide();
      //    // this.fileInfos = this.uploadService.getFiles();
      //  }
      //});

    }

  }


  async upload(idx, file: File) {
    this.progressInfos[idx] = { value: 0, fileName: file.name };
    let npiDataFileForm = new FormData();

    npiDataFileForm.append('NPIDataSource', file);
    this.loaderService.show();
    await this._baseservice.uploadwithprogress('Common/UploadNPIData', npiDataFileForm, this.progress)
      .toPromise()
      .then((event) => {
        if (event.type === HttpEventType.UploadProgress) {
          this.progressInfos[idx].value = Math.round(100 * event.loaded / event.total);
        } else if (event instanceof HttpResponse) {
          
          console.log("file uploaded");
          this.loaderService.hide();
          // this.fileInfos = this.uploadService.getFiles();
        }
      })

    //.subscribe(
    //event => {
    //  if (event.type === HttpEventType.UploadProgress) {
    //    this.progressInfos[idx].value = Math.round(100 * event.loaded / event.total);
    //  } else if (event instanceof HttpResponse) {
    //    debugger;
    //    console.log("file uploaded");
    //    this.loaderService.hide();
    //    // this.fileInfos = this.uploadService.getFiles();
    //  }
    //},
    //err => {
    //  this.loaderService.hide();
    //  this.progressInfos[idx].value = 0;
    //  //this.message = 'Could not upload the file:' + file.name;

    //});
    // let npiDataFileForm = new FormData();

    //npiDataFileForm.append('NPIDataSource', file);
    //this.showProgress = true;
    //this._baseservice
    //  .uploadwithprogress(
    //    'Common/UploadNPIData',
    //    npiDataFileForm,this.progress
    //  )
    //  .subscribe(
    //    event => {
    //      if (event.type === HttpEventType.UploadProgress) {
    //        this.progress = Math.round(100 * event.loaded / event.total);
    //      } else if (event instanceof HttpResponse) {
    //        console.log("File Uploaded");
    //      }
    //  },
    //    (error) => {
    //      this.progress = 0;
    //      console.error(error);
    //      this.uploadStatus = "";
    //      this._snackBar.open(
    //        `File could not be uploaded!${error.error && error.error.resultStatus
    //          ? ": " + error.error.resultStatus.message
    //          : ""
    //        }`,
    //        "Ok",
    //        {
    //          duration: 5000,
    //        }
    //      );
    //    });
    //event.target.value = '';
    //this.loaderService.hide();
  }
}
